export default __webpack_public_path__ + "static/media/pink.a6d4c046.png";